"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.avenirBoldItalic = exports.avenirBold = exports.avenirDemiItalic = exports.avenirDemi = exports.avenirItalic = exports.avenirRegular = exports.avenirLightItalic = exports.avenirLight = void 0;

var avenirLight = function avenirLight() {
  return "\n    font-weight: 300;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirLight = avenirLight;

var avenirLightItalic = function avenirLightItalic() {
  return "\n    font-weight: 300;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirLightItalic = avenirLightItalic;

var avenirRegular = function avenirRegular() {
  return "\n    font-weight: 400;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirRegular = avenirRegular;

var avenirItalic = function avenirItalic() {
  return "\n    font-weight: 400;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 500;\n    }\n  ";
};

exports.avenirItalic = avenirItalic;

var avenirDemi = function avenirDemi() {
  return "\n    font-weight: 500;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirDemi = avenirDemi;

var avenirDemiItalic = function avenirDemiItalic() {
  return "\n    font-weight: 500;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirDemiItalic = avenirDemiItalic;

var avenirBold = function avenirBold() {
  return "\n    font-weight: 600;\n    font-style: normal;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirBold = avenirBold;

var avenirBoldItalic = function avenirBoldItalic() {
  return "\n    font-weight: 600;\n    font-style: italic;\n\n    b, strong {\n      font-weight: 600;\n    }\n  ";
};

exports.avenirBoldItalic = avenirBoldItalic;


//////////////////
// WEBPACK FOOTER
// ./node_modules/calcite-react/utils/type.js
// module id = 1565
// module chunks = 0